import initialstate from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';

export function entityFormsReducers(state = initialstate.entityForms, action) {
	switch (action.type) {
		case types.CREATE_ENTITY_FORM:
			if (action.response) {
				return [...state, action.response];
			} else {
				return {
					errorMessage: action.meta.auth.error
				};
			}
		case types.DELETE_DOCUMENT_BY_ID: {
			if (action && action.responseObj.status === HttpStatusCodes.Ok) {
				return state.filter((doc) => doc.documentID !== action.documentId);
			}
			return state;
		}
		case types.UPDATE_DOCUMENT: {
			if (action && action.responseObj.status === HttpStatusCodes.Ok) {
				const updatedDocument = state.map((doc) => {
					if (doc.documentID === action.documentId) {
						return {...doc, ...action.meta.api.data};
					}
					return doc;
				});
				return updatedDocument;
			}
			return state;
		}
		default:
			return state;
	}
}
